import React, { useRef, useState, useCallback } from 'react';
import './TiltedCard.css';

const TiltedCard = ({ children, className = '', intensity = 15 }) => {
  const cardRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [style, setStyle] = useState({
    transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
    transition: 'transform 0.3s cubic-bezier(0.23, 1, 0.32, 1)'
  });

  const handleMouseMove = useCallback((e) => {
    if (!cardRef.current || !isHovered) return;

    const card = cardRef.current;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    
    const rotateX = ((y - centerY) / centerY) * -intensity;
    const rotateY = ((x - centerX) / centerX) * intensity;

    setStyle({
      transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05, 1.05, 1.05)`,
      transition: 'none'
    });
  }, [intensity, isHovered]);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
    setStyle({
      transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
      transition: 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)'
    });
  }, []);

  const handleMouseEnter = useCallback((e) => {
    setIsHovered(true);
    // Set a brief transition for smooth entry
    setStyle(prevStyle => ({
      ...prevStyle,
      transition: 'transform 0.2s cubic-bezier(0.23, 1, 0.32, 1)'
    }));
    
    // Immediately calculate initial position to prevent jump
    if (cardRef.current) {
      const card = cardRef.current;
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const rotateX = ((y - centerY) / centerY) * -intensity;
      const rotateY = ((x - centerX) / centerX) * intensity;

      // Use requestAnimationFrame to ensure smooth initial transition
      requestAnimationFrame(() => {
        setStyle({
          transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05, 1.05, 1.05)`,
          transition: 'transform 0.2s cubic-bezier(0.23, 1, 0.32, 1)'
        });
        
        // After initial transition, remove transition for smooth tracking
        setTimeout(() => {
          setStyle(prevStyle => ({
            ...prevStyle,
            transition: 'none'
          }));
        }, 200);
      });
    }
  }, [intensity]);

  return (
    <div
      ref={cardRef}
      className={`tilted-card ${className}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      style={style}
    >
      {children}
    </div>
  );
};

export default TiltedCard;

